// extracted by mini-css-extract-plugin
export var container = "Instagram-module--container--bSso1";
export var header = "Instagram-module--header--1tobE";
export var papaki = "Instagram-module--papaki--3or5Y";
export var gallery = "Instagram-module--gallery--3TPoh";
export var imgWrapper = "Instagram-module--img-wrapper--1b32F";
export var img = "Instagram-module--img--149QO";